
import { defineComponent, ref } from "vue";
import router from "@/router/index";
import store from "@/store";
import { doLogin, getMerchantResourceDto } from "@/api/login";
import md5 from "js-md5";
// import Justify from "wangeditor/dist/menus/justify";
export default defineComponent({
  name: "login",
  setup() {
    // 登录成功获取动态路由存取
    // const aa = ref<{name:string}>({
    //   name:"小王"
    // })
    // console.log(aa.value.name);

    let checked = ref(true);
    checked.value = localStorage.getItem("userForm") ? true : false;
    const FormData = ref<any>({
      pagePassword: localStorage.getItem("userForm") ? JSON.parse(localStorage.getItem("userForm") as string).pagePassword : "",
      password: "",
      username: localStorage.getItem("userForm") ? JSON.parse(localStorage.getItem("userForm") as string).username : "",
    });

    let name = ref("");
    let pass = ref("");
    let Validation_name = ref(false);
    let Validation_pass = ref(false);
    let isee = ref(false);
    const asyncRouterMap = ref<any>([]);
    const tologin = () => {
      //登录输入验证
      if (!FormData.value.username && !FormData.value.pagePassword) {
        Validation_name.value = true;
        Validation_pass.value = true;
        return;
      } else if (!FormData.value.username && FormData.value.pagePassword) {
        Validation_name.value = true;
        Validation_pass.value = false;
        return;
      } else if (FormData.value.username && !FormData.value.pagePassword) {
        Validation_pass.value = true;
        Validation_name.value = false;
        return;
      } else {
        Validation_name.value = false;
        Validation_pass.value = false;
        FormData.value.password = md5(FormData.value.pagePassword).toUpperCase();
        let dataForm = {
          password: FormData.value.password,
          username: FormData.value.username,
        };
        doLogin(dataForm).then((res: any) => {
          if (res.code == 1) {
            if (checked.value) {
              localStorage.setItem("userForm", JSON.stringify(FormData.value));
            } else {
              localStorage.removeItem("userForm");
            }
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userInfo", JSON.stringify(res.data.manageAdmin));
            getMerchantResourceDto(res.data.roleNo).then((res2: any) => {
              res2.data.resourceDto.allRes.forEach((item: any) => {
                res2.data.resourceDto.selectedRes.forEach((item2: any) => {
                  if (item.id == item2.parentId) {
                    asyncRouterMap.value.push({
                      id: item.id,
                      path: item.resourceUrl,
                      name: item.resourceName,
                      children: [],
                      resourceIoc: item.resourceIoc,
                    });
                  }
                });
              });
              asyncRouterMap.value.forEach((item: any) => {
                res2.data.resourceDto.selectedRes.forEach((item2: any) => {
                  if (item.id == item2.parentId) {
                    item.children.push({ path: item2.resourceUrl, name: item2.resourceName });
                  }
                });
              });
              console.log(asyncRouterMap.value);
              localStorage.setItem("asyncRouterMap", JSON.stringify(asyncRouterMap.value));
              store.commit("SET_USER_ROUTER", asyncRouterMap.value);
              router.push("/home");
            });
          }
        });
      }
    };
    // if (localStorage.getItem("userForm")) {
    //   FormData.value.username = JSON.parse(localStorage.getItem("userForm") as string).username;
    //   FormData.value.pagePassword = JSON.parse(localStorage.getItem("userForm") as string).pagePassword;
    //   tologin();
    // }
    // 密码显示隐藏
    const iseeFn = () => {
      isee.value = !isee.value;
    };
    return {
      isee,
      Validation_name,
      Validation_pass,
      checked,
      name,
      pass,
      tologin,
      iseeFn,
      FormData,
    };
  },
});
